import React, { useState, useContext } from 'react';
import TeamSwitcher from './TeamSwitcher';
import SglContext from '../../SglContext';

const CreateTeamForm = ({
  teamContext,
  onCreateTeam,
  isCreating,
  currentTeamId,
  onTeamSwitch,
  showNotification,
  onCancel
}) => {
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });
  const Sgl = useContext(SglContext);

  const handleSubmit = async () => {
    if (!formData.name.trim()) {
      // Use inline notification instead of alert
      if (showNotification) {
        showNotification('Please provide a team name', 'warning', 4000);
      }
      return;
    }

    try {
      // Call the parent's create team handler
      const result = await onCreateTeam(formData);
      
      // Only handle success case here - parent handles the toast notifications
      if (result) {
        // Handle localStorage and context updates
        if (result.teamId) {
          localStorage.setItem('currentTeamId', result.teamId);
          if (Sgl && Sgl.setCurrentTeam) {
            Sgl.setCurrentTeam(result.teamId);
          }
        }
        
        // Reset form
        setFormData({ name: '', description: '' });
        
        // Refresh teams if method exists
        if (Sgl && Sgl.refreshUserTeams) {
          Sgl.refreshUserTeams();
        }
      }
    } catch (error) {
      console.error('Failed to create team:', error);
      // Parent component handles error notifications, but fallback just in case
      if (showNotification) {
        showNotification('Team creation failed. Please try again.', 'error', 6000);
      }
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // Handle Enter key submission
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isCreating && formData.name.trim()) {
      handleSubmit();
    }
  };

  return (
    <div className="team-management wrapper-padding">
      {/* <div className="team-switcher-section create-mode-header">
        <TeamSwitcher
          teams={teamContext?.userTeams || []}
          currentTeamId={currentTeamId}
          onTeamSwitch={onTeamSwitch}
          showCreateOption={true}
          integrated={false}
        />
      </div> */}

      <div className="create-team-container modern-team-modal ">
        <div className="create-team-title">Create Your Team</div>
        <div className="create-team-description">
          {teamContext?.userTeams?.length > 0
            ? "Create your own team to have full control over team management and invite your own members."
            : "You don't have a team yet. Create your team to start inviting members and managing permissions for your horse show operations."
          }
        </div>
        <div className="create-team-body">
          <div className="modern-form-group">
            <label>Team Name *</label>
            <input
              type="text"
              className="modern-input"
              placeholder="Enter your team name (e.g., Sunset Stables Team)"
              value={formData.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isCreating}
              maxLength={100}
              autoFocus
            />
            {formData.name.length > 80 && (
              <div style={{ 
                fontSize: '12px', 
                color: formData.name.length > 95 ? '#dc2626' : '#d97706',
                marginTop: '4px'
              }}>
                {formData.name.length}/100 characters
              </div>
            )}
          </div>

          <div className="modern-form-group">
            <label>Description</label>
            <textarea
              className="modern-input"
              placeholder="Optional description for your team"
              value={formData.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
              disabled={isCreating}
              maxLength={500}
              rows={3}
            />
            {formData.description.length > 400 && (
              <div style={{ 
                fontSize: '12px', 
                color: formData.description.length > 475 ? '#dc2626' : '#d97706',
                marginTop: '4px'
              }}>
                {formData.description.length}/500 characters
              </div>
            )}
          </div>

          <div className="create-team-buttons">
            {onCancel && (
              <button
                className="modern-btn-cancel"
                onClick={onCancel}
                disabled={isCreating}
              >
                Cancel
              </button>
            )}
            
            <button
              className="modern-btn-primary"
              onClick={handleSubmit}
              disabled={isCreating || !formData.name.trim()}
            >
              {isCreating ? (
                <>
                  <span style={{ 
                    display: 'inline-block', 
                    width: '14px', 
                    height: '14px', 
                    border: '2px solid transparent', 
                    borderTop: '2px solid currentColor', 
                    borderRadius: '50%', 
                    animation: 'spin 1s linear infinite',
                    marginRight: '8px'
                  }}></span>
                  Creating Team...
                </>
              ) : (
                'Create Team'
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Add CSS for spinner animation */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default CreateTeamForm;